import { useState, useEffect, useContext } from "react";
import { AppContext } from "../App";
import { 
  BsFillSuitDiamondFill,
  BsFillSuitHeartFill,
  BsSuitClubFill,
  BsFillSuitSpadeFill,
} from 'react-icons/bs'
import { GameContext as Arubastini } from '../boards/ArubastiniBoard';
import { GameContext as Lastcard } from "../boards/LastcardBoard";


export default function PlayedCard(props) {

  const app = useContext(AppContext);
  const arubastini = useContext(Arubastini);
  const lastcard = useContext(Lastcard);

  const gameContext = arubastini || lastcard;

  const [ position, setPosition ] = useState(props.position);
  const [ data, setData ] = useState(props.data);

  useEffect(() => {
    setData(props.data);
  }, [ props.data ])

  useEffect(() => {
    setPosition(props.position);
  }, [ props.position ])


  return (
    <div 
      className="coreOnePlayedCard"
      data-symbol={data.symbol}
      data-position={app.gameData.type+"-"+position}
    >
      <span className="mChar1">{data.character}</span>
      <span className="mChar2">{data.character}</span>
      {
        (data.symbol === 'kisu') ?
        <>
          <BsFillSuitDiamondFill
            className="mSymbol1"
          />
          <BsFillSuitDiamondFill
            className="mSymbol2"
          />
          <BsFillSuitDiamondFill
            className="mSymbolMid"
          />
        </>
        :null
      }
      
      {
        (data.symbol === 'kopa') ?
        <>
          <BsFillSuitHeartFill
            className="mSymbol1"
          />
          <BsFillSuitHeartFill
            className="mSymbol2"
          />
          <BsFillSuitHeartFill
            className="mSymbolMid"
          />
        </>
        :null
      }

      {
        (data.symbol === 'jembe') ?
        <>
          <BsFillSuitSpadeFill
            className="mSymbol1"
          />
          <BsFillSuitSpadeFill
            className="mSymbol2"
          />
          <BsFillSuitSpadeFill
            className="mSymbolMid"
          />
        </>
        :null
      }

      {
        (data.symbol === 'karanga') ?
        <>
          <BsSuitClubFill
            className="mSymbol1"
          />
          <BsSuitClubFill
            className="mSymbol2"
          />
          <BsSuitClubFill
            className="mSymbolMid"
          />
        </>
        :null
      }
      
    </div>
  )
}